import { createSelector } from '@reduxjs/toolkit'
import moment from 'moment'

import { getClient } from '../root.selectors'
import { RootState } from '../root.reducer'

export const getClientLoans = (state) => getClient(state).clientLoans
export const isClientLoansLoading = createSelector(getClientLoans, (slice) => slice.status === 'loading')
export const getClientLoansData = createSelector(getClientLoans, (slice) => slice.data.filter((x) => x.ID))

const getClientParallelLoans = (state) => getClient(state).parallelLoans
const isClientParallelLoansLoading = createSelector(getClientParallelLoans, (slice) => slice.status === 'loading')
const getClientParallelLoansById = createSelector(
  [getClientParallelLoans, (_state, id) => id],
  (slice, clientId) => slice.byId[clientId] || [],
)

const getClientRelatedLoans = (state) => getClient(state).relatedLoans
const isClientRelatedLoansLoading = createSelector(getClientRelatedLoans, (slice) => slice.status === 'loading')
const getClientRelatedLoansById = createSelector(
  [getClientRelatedLoans, (_state, id) => id],
  (slice, clientId) => slice.byId[clientId] || [],
)

export const isRelatedParallelLoansLoading = (state) =>
  isClientParallelLoansLoading(state) || isClientRelatedLoansLoading(state)
export const getRelatedParallelLoans = createSelector(
  [getClientParallelLoansById, getClientRelatedLoansById],
  (parallelLoans, relatedLoans) => {
    return [...parallelLoans, ...relatedLoans].sort((a, b) =>
      moment(a.DisburseDate).isAfter(moment(b.DisburseDate)) ? 1 : -1,
    )
  },
)

export const getClientData = (state: RootState) => getClient(state).clientData
export const isClientDataLoading = createSelector(getClientData, (slice) => slice.status === 'loading')
export const getClientsData = (instanceName?: string) => {
  return createSelector(getClientData, (slice) => slice.data[instanceName])
}
export const getClientsFetchSucceeded = (state, { instanceName }) => {
  return getClient(state).clientData.status === 'loaded'
}

export const getClientsCount = (state, { instanceName }) => {
  const res = getClient(state).clientData.data?.[instanceName] || []
  return res.length
}

export const getClientReqFieldsFetchSucceeded = (state) => getClient(state).reqFields.status === 'loaded'
